import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import ServerSideProcessingHeader from "./ServerSideProcessingHeader";
import { SERVER_COLUMN, SERVER_DATA } from "../../../../Data/DataTable/ServerSideData";

const ServerSideProcessing = () => {
  return (
    <Col sm="12">
      <Card>
        <ServerSideProcessingHeader/>
        <CardBody>
          <div className="table-responsive">
            <DataTable data={SERVER_DATA} columns={SERVER_COLUMN} striped highlightOnHover pagination/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ServerSideProcessing;
